import React, { useMemo } from "react";
import i18n from "i18next";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import { MOBILE_PRO_POPUP_CONTENT } from "./index.content";
import JPG_SCREENSHOT from "../../../assets/images/raster/Layout/MobileProPopup/screenshot.jpg";
import EN from "../../../locales/en/mobile-pro-popup.json";
import DE from "../../../locales/de/mobile-pro-popup.json";
import CN from "../../../locales/cn/mobile-pro-popup.json";
import JA from "../../../locales/ja/mobile-pro-popup.json";
import ES from "../../../locales/es/mobile-pro-popup.json";
import FR from "../../../locales/fr/mobile-pro-popup.json";
import { getTrueClasses } from "../../../helpers";
import TrackedLink from "../../Analytics/TrackedLink";
import "./index.scss";
import "./local.scss";

const resources = {
  en: { translation: EN },
  de: { translation: DE },
  cn: { translation: CN },
  ja: { translation: JA },
  es: { translation: ES },
  fr: { translation: FR },
};

const MobileProPopup = ({ language = "en", mode = "default" }) => {
  const LANGUAGE = useMemo(
    () => (resources[language] ? language : "en"),
    [language]
  );
  i18n.init({ lng: LANGUAGE, resources });
  const t = i18n.t;

  return (
    <div
      className={getTrueClasses(
        "GCL-MPP",
        mode !== "default" && `GCL-MPP_${mode}`,
        LANGUAGE !== "en" && `GCL-MPP_${LANGUAGE}`
      )}
    >
      <div className="GCL-MPP__screen">
        <img
          className="GCL-MPP__screenshot"
          src={JPG_SCREENSHOT}
          alt=""
          loading="lazy"
        />
      </div>
      <h2 className="GCL-MPP__title">{t("Dear Customer!")}</h2>
      <p className="GCL-MPP__text GCL-MPP__text_t1">
        {parse(
          t(
            "The AMZScout PRO AI Extension is only available for desktop users through the Chrome Web Store."
          )
        )}
      </p>
      <p className="GCL-MPP__text GCL-MPP__text_t2">
        {parse(
          t(
            "Try mobile-friendly web tools specifically designed for Amazon sellers."
          )
        )}
      </p>
      <TrackedLink
        classes="GCL-MPP__link GCL-MPP__link_l1"
        category="MobileProPopup"
        action="Continue to other AMZScout tools"
        path="/app/#/database/"
      >
        {t("Continue to other AMZScout tools")}
      </TrackedLink>
      <p className="GCL-MPP__text GCL-MPP__text_t3">
        {parse(t(MOBILE_PRO_POPUP_CONTENT.t3[mode]))}
      </p>
      <p className="GCL-MPP__text GCL-MPP__text_t4">
        {parse(t(MOBILE_PRO_POPUP_CONTENT.t4[mode]))}
      </p>
      <TrackedLink
        classes="GCL-MPP__link GCL-MPP__link_l2"
        category="MobileProPopup"
        action={MOBILE_PRO_POPUP_CONTENT.l2[mode]?.text}
        path={MOBILE_PRO_POPUP_CONTENT.l2[mode]?.link || ""}
      >
        {t(MOBILE_PRO_POPUP_CONTENT.l2[mode]?.text)}
      </TrackedLink>
    </div>
  );
};
MobileProPopup.propTypes = {
  language: PropTypes.string,
  mode: PropTypes.string,
};

export default MobileProPopup;
